/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { KiteDailyTrxInfo } from './KiteDailyTrxInfo';

export type KiteHomeTotalTrxInfo = {
    TRXHTP: KiteHomeTotalTrxInfo.TRXHTP;
    TRXTP: KiteHomeTotalTrxInfo.TRXTP;
    DAVGTRXC: string;
    CNGP: string;
    DTRXLIST: Array<KiteDailyTrxInfo>;
};

export namespace KiteHomeTotalTrxInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
        CLAIM = 'CLAIM',
        DEPOSIT = 'DEPOSIT',
        USER = 'USER',
        AVG_GAS_PRICE = 'AVG_GAS_PRICE',
    }


}

